import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const KassaService = {
  async getKassas(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get(`kassa/v1/kassas/`, { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientKassaInfo(kassaId) {
    const res = await axios.get(`kassa/v1/kassa/${kassaId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getOfdKassas(kassaId) {
    const res = await axios.get(`kassa/v1/${kassaId}/user/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getShifts(kassaId, page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get(`kassa/v1/${kassaId}/shifts/`, { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getChecks(shiftId, page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get(`kassa/v1/${shiftId}/checks/`, { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async submitApplication(clientId) {
    const params = generateQueryParams({
      client_id: clientId,
    });

    const res = await axios.post(`kassa/v1/submit_application/`, params);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async updateKassa(kassaId, payload) {
    const res = await axios.put(`kassa/v1/kassa/${kassaId}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteKassa(kassaId) {
    const res = await axios.delete(`kassa/v1/kassa/${kassaId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async downloadShift(kassaId, shiftId) {
    const res = await axios.get(
      `kassa/v1/${kassaId}/shift-report/${shiftId}/pdf/`,
      {
        responseType: 'arraybuffer',
      }
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async downloadCheck(kassaId, checkId) {
    const res = await axios.get(`kassa/v1/${kassaId}/checks/${checkId}/pdf/`, {
      responseType: 'arraybuffer',
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
